import TheOrganizationHome from "../views/TheOrganizationHome";
import store from "../../core/store/store";

export default [
  {
    path: "/organization/:id",
    name: "organizationHome",
    component: TheOrganizationHome,
    props: true,
    beforeEnter(routeTo, routeFrom, next) {
      if (
        !store.state.organization.accountOrganizations.some(
          organization => organization.organization.id == routeTo.params.id
        )
      )
        next({ name: "home" });
      else next();
    }
  }
];
